export const ImageExtensions = [
    'jpg', 
    'jpeg', 
    'png', 
    'gif', 
    'bmp'
]
export const ThreeDModelExtensions = [
    'glb'
]